/**
 * Mínimo de caracteres de una CIEC tras recortar espacios (B-075). Es el mismo que exige el backend
 * (`normalizeAndValidateCiec` en api-rendafin): si el panel pidiera menos, el usuario vería el rechazo
 * hasta después de enviarla.
 */
export const CIEC_MIN_LENGTH = 8
